<template>
    <b-navbar type="dark" class="lab-sub-header-home-page">
        <b-navbar-nav class="home-view-nav">
            <home-page-view-menu />
        </b-navbar-nav>

        <b-navbar-nav class="instruments-nav">
            <instruments-menu v-if="instruments.length" />
        </b-navbar-nav>

        <b-nav-text v-if="!isFdaFriendly" class="tutorial-nav">
            <b-button
                v-b-tooltip.hover
                size="lg"
                variant="icon"
                :title="$translate('tutorials')"
                @click="showTutorial"
            >
                <video-icon />
            </b-button>
        </b-nav-text>

        <b-nav-text class="share-nav">
            <share-button />
        </b-nav-text>
    </b-navbar>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import UIUtils from '../../business/utils/UIUtils'

import HomePageViewMenu from './partials/HomePageViewMenu'
import InstrumentsMenu from './partials/InstrumentsMenu'
import ShareButton from './ShareButton'
import VideoIcon from './partials/icons/VideoIcon'

export default {
    name: 'LabSubHeaderHomePage',
    components: { VideoIcon, HomePageViewMenu, InstrumentsMenu, ShareButton },
    computed: {
        ...mapState({
            instruments: state => state.timelapse.instruments
        }),
        ...mapGetters({
            tutorialForCurrentView: 'onboarding/tutorialForCurrentView',
            isFdaFriendly: 'common/isFdaFriendly'
        })
    },
    methods: {
        showTutorial() {
            this.$log.actionEvent('show_tutorial_for_view')

            if (this.tutorialForCurrentView) {
                UIUtils.showModal('video_tutorial', data => {
                    data.componentTutorial = this.tutorialForCurrentView(this.$route)
                })
            }
        }
    }
}
</script>

<style lang="scss">
.lab-sub-header-home-page {
    height: $sub-header-height;
    border-bottom: $border-narrow-dark;
    box-shadow: $sub-header-shadow;
    z-index: 20;

    .home-view-nav {
        margin-right: auto;
    }

    .instruments-nav {
        @media screen and #{$new-break3close} {
            margin-left: auto;
        }
        @media screen and #{$new-break4open} {
            display: none;
        }
    }
    .tutorial-nav {
        margin-right: 0.5rem;
    }
    .share-nav {
        margin-right: 0.5rem;
    }

    @media screen and #{$new-break2close} {
        padding: 0;
    }

    @media screen and #{$new-break3close} {
        .tutorial-nav,
        .share-nav {
            display: none;
        }
    }

    @media print {
        color: $dark !important;
        background-color: $white !important;
        display: flex;
        border-bottom: 0.1rem $dark solid;
        margin-bottom: 0;
        padding: 0 2rem !important;

        span {
            color: $dark !important;
        }

        .instruments-nav,
        .tutorial-nav,
        .share-nav {
            display: none;
        }
    }
}
</style>
